input SchedulingInviteInput {
  case_id: String!
  client_id: String!
  title: String!
  user_ids: [String!]!
}

type SchedulingInvite {
  meeting_title: String
}

type SchedulerAvailabilitySlot {
  start_time: Int!
  end_time: Int!
}

type SchedulerAvailabilitySlots {
  time_slots: [SchedulerAvailabilitySlot!]!
}

type SchedulerEvent {
  end_time: Int
  start_time: Int
  title: String
  event_id: ID
}

type SchedulerEventClient {
  email: String!
  first_name: String
  last_name: String
}

type SchedulerEventInfo {
  client: SchedulerEventClient!
  event: SchedulerEvent
  duration_minutes: Int!
  organisation_logo: String!
}
